export function shouldBlurAfterPointerScrub(pointerType: string): boolean {
  return pointerType === "mouse" || pointerType === "pen" || pointerType === "touch";
}

export function shouldReleaseTimelineFocusAfterPointerScrub(wasFocusedBeforeScrub: boolean): boolean {
  return !wasFocusedBeforeScrub;
}
